import axios from '../../utils/axios';
import CRUD from './crud'

const coaches = new CRUD('coaches', 'superior-judge')

export default Object.assign(
    coaches,
    {
        reducers: {
            ...coaches.reducers
        },

        getDiscounts: (id, id_tournament = null, id_tournament_participant = null) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/coach-discounts/${id}?id_tournament=${id_tournament}&id_tournament_participant=${id_tournament_participant}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        getBookingDiscounts: (id, id_tournament = null, id_tournament_booking = null) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/coach-booking-discounts/${id}?id_tournament=${id_tournament}&id_tournament_booking=${id_tournament_booking}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        getTicketDiscounts: (id, id_tournament = null, id_ticket_payment = null) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/coach-ticket-discounts/${id}?id_tournament=${id_tournament}&id_ticket_payment=${id_ticket_payment}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        notify: (message, filters={}) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/coaches/notify`, {
                        params: {
                            'message': message,
                            'filters': filters
                        }
                    })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        sendMessage: (id, message) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/coaches/${id}/message`, {message: message})
                } catch (error) {
                    console.error(error);
                }
            };
        },

        togglePostpaid: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/coaches/${id}/toggle-postpaid`)
                } catch (error) {
                    console.error(error);
                }
            };
        },
    }
)
